import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from "rxjs";
import {SocketService} from "../../_services/socket.service";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {ContentService} from "../../_services/content.service";

@Component({
    selector: 'app-online-status-badge',
    templateUrl: './online-status-badge.component.html',
    styleUrl: './online-status-badge.component.scss'
})
export class OnlineStatusBadgeComponent implements OnInit, OnDestroy {
    @Input() userId: number = 0;
    @Input() isStaff: boolean | undefined = false;
    isOnline: boolean = false;
    private subscription: Subscription | undefined;
    hide: boolean | undefined = false;

    constructor(private socketService: SocketService,
                private contentService: ContentService,) {
        this.contentService.getCurrentDashboardCommunity()
            .pipe(takeUntilDestroyed())
            .subscribe(community => {
                this.hide = community?.disable_online_icon_next_to_profile_picture;
            });
    }

    ngOnInit(): void {
        this.subscription = this.socketService
            .isUserOnline(this.userId)
            .subscribe(online => {
                this.isOnline = online;
            });
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
